import React, { useContext, useEffect, useState } from 'react';
import OrderSubmission from './submit/OrderSubmission';
import { calculateDeadline } from './OrderHeader';

import { faClock } from '@fortawesome/free-regular-svg-icons';
import OrderContext from '../OrderContext';
import { IconWrapper } from '../../../common/IconWrapper';

export default function SmallOrderHeader() {
    const [remainingTime, setRemainingTime] = useState();
    const { orderHeader, orderId, singleMoq } = useContext(OrderContext);
    let deadlineInSeconds;
    if (orderHeader.orderStatus !== 'DELETED') {
        deadlineInSeconds = orderHeader.deadline;
    }

    useEffect(() => {
        let intervalId;
        if (deadlineInSeconds) {
            intervalId = setInterval(() => {
                deadlineInSeconds--;
                setRemainingTime(calculateDeadline(deadlineInSeconds));
                if (deadlineInSeconds <= 0) {
                    clearInterval(intervalId);
                }
            }, 1000);
        }
        return () => clearInterval(intervalId); // Cleanup function to stop interval when component is destroyed.
        // eslint-disable-next-line
    }, [orderHeader]);

    return (
        <div className={'content header-wrapper flex'}>
            <div>
                <strong>Order:</strong>
                <span>{orderId}</span>
                {deadlineInSeconds && orderHeader.orderStatus === 'OPEN' && (
                    <p className={'clock flex'}>
                        <IconWrapper icon={faClock} />
                        <span className={'countdown'}>{remainingTime}</span> remaining
                    </p>
                )}
            </div>
            <div className={'center-info flex'}>
                {singleMoq && (
                    <div>
                        <strong>MOQ:</strong>
                        <span>
                            {singleMoq.submittedCases + singleMoq.orderCases}/{singleMoq.minimumOrderQtyNoSurcharge}
                        </span>
                    </div>
                )}
                <div>
                    <strong>Total lines:</strong>
                    <span>{orderHeader.totalLines}</span>
                </div>
                <div>
                    <strong>Total cases:</strong>
                    <span>{orderHeader.totalCases}</span>
                </div>
                <div>
                    <p>
                        <strong className={'cost-label'}>Total cost:</strong>
                    </p>
                    <p>
                        <strong className={'order-cost'}>
                            £{Math.floor(orderHeader.totalCost)}
                            <sup>{(orderHeader.totalCost % 1).toFixed(2).substring(1)}</sup>
                        </strong>
                    </p>
                </div>
            </div>
            <div>{orderHeader.orderStatus === 'OPEN' && <OrderSubmission />}</div>
        </div>
    );
}
